export default __webpack_public_path__ + "static/sam42_law-e847ac5277b77fa24ab477a557a4170d.jpg";